<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
  >
    <v-data-table
      :headers="headers"
      :items="users"
      :loading="loading"
      sort-by="PlayerNickname"
      class="elevation-1"
      :items-per-page="-1"
      hide-default-footer
    >

      <template v-for="value in columns" #[`item.${value}`]="{ item }">
        {{ !item[value] ? '-' : timeToString(item[value]) }}
      </template>
    </v-data-table>
  </v-dialog>
</template>

<script>
import helper from '../../plugins/helpers/mixin-helper'
export default {
  mixins: [
    helper
  ],
  data () {
    return {
      dialog: true,
      loading: false,
      users: [],
      columns: [],
      headers: [
        {
          text: 'Player',
          align: 'start',
          sortable: true,
          value: 'PlayerNickname'
        }
      ]
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async getData () {
      if (!this.$route.query.build_id) {
        return
      }

      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/telemetry/hardware/input-methods`, {
          params: {
            build_id: this.$route.query.build_id,
            user_id: this.$route.query.user_id,
            filteredByPlayer: true
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.headers = [
          {
            text: 'Player',
            align: 'start',
            sortable: true,
            value: 'PlayerNickname'
          },
          ...data.columns.map(column => ({
            text: column,
            align: 'start',
            sortable: true,
            value: column
          }))
        ]

        this.columns = data.columns
        this.users = data.rows
      }
      this.loading = false
    }
  }
}
</script>